/**
 * localization-footer.js
 *
 * Synchronises external-shop links from the header country selector
 * into the footer country selector, merging them alphabetically
 * with the native Shopify country buttons.
 *
 * Requirements:
 *  - Header country selector has [data-localization-country]
 *    with external links marked by [data-country-iso] attribute.
 *  - Footer country selector has [data-localization-country][data-sync-pending]
 *    and lives inside <footer>.
 *
 * Until sync completes the footer selector stays visually disabled
 * (pointer-events: none; opacity: 0.5) via the [data-sync-pending] attribute.
 */
(function () {
  'use strict';

  function removePendingState(container) 
  {
    if (!container) {
      return;
    }

    container.removeAttribute('data-sync-pending');
    var btn = container.querySelector(':scope > button[aria-controls]');

    if (btn) {
      btn.removeAttribute('disabled');
    }
  }

  function getOptionLabel(el) 
  {
    var spans = el.querySelectorAll(':scope > span');

    for (var i = 0; i < spans.length; i++) {
      if (
        spans[i].classList.contains('country-flags') ||
        spans[i].classList.contains('popover-listbox__icon')
      ) {
        continue;
      }

      return (spans[i].textContent || '').trim();
    }

    return (el.textContent || '').trim();
  }

  function sync() 
  {
    var headerSelector = document.querySelector('header [data-localization-country]') ||
      document.querySelector('.shopify-section--header [data-localization-country]');

    var footerSelector = document.querySelector('footer [data-localization-country][data-sync-pending]') ||
      document.querySelector('.shopify-section--footer [data-localization-country][data-sync-pending]');

    if (!footerSelector) {
      return;
    }

    if (!headerSelector) {
      removePendingState(footerSelector);
      return;
    }

    var headerExternalLinks = headerSelector.querySelectorAll('a[data-country-iso]');

    if (!headerExternalLinks.length) {
      removePendingState(footerSelector);
      return;
    }

    var externalISOs = {};

    for (var i = 0; i < headerExternalLinks.length; i++) {
      externalISOs[headerExternalLinks[i].getAttribute('data-country-iso').toUpperCase()] = true;
    }

    var footerListbox = footerSelector.querySelector('x-listbox, [role="listbox"]');

    if (!footerListbox) {
      removePendingState(footerSelector);
      return;
    }

    var nativeButtons = footerListbox.querySelectorAll('button[name="country_code"]');

    for (var j = 0; j < nativeButtons.length; j++) {
      if (externalISOs[nativeButtons[j].value.toUpperCase()]) {
        nativeButtons[j].remove();
      }
    }

    for (var k = 0; k < headerExternalLinks.length; k++) {
      var clonedLink = headerExternalLinks[k].cloneNode(true);
      var clonedLabel = getOptionLabel(clonedLink).toLowerCase();

      var inserted = false;
      var existingOptions = footerListbox.querySelectorAll(
        'button[name="country_code"], a[data-country-iso]'
      );

      for (var m = 0; m < existingOptions.length; m++) {
        var existingLabel = getOptionLabel(existingOptions[m]).toLowerCase();
        
        if (clonedLabel < existingLabel) {
          footerListbox.insertBefore(clonedLink, existingOptions[m]);
          inserted = true;
          break;
        }
      }

      if (!inserted) {
        footerListbox.appendChild(clonedLink);
      }
    }

    removePendingState(footerSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();